import { useNavigate } from "react-router";
import { Button, EmptyState, PageHeader, PageShell, Tabs, icons } from "@bruntworkwear-apps/ui";
import { useRun } from "@/app/providers";
import { useAppConfig } from "@/modules/overview";
import { ReviewPanelView } from "./components/ReviewPanel.view";
import { RunSummary } from "./components/RunSummary";
import { useReviewTabs } from "./useReviewTabs";
import styles from "./ReviewModule.module.css";

/**
 * Step two: what the run computed, and what it could not resolve.
 *
 * Reads entirely from the run context - one POST returned all of this, so
 * nothing is refetched and no two views can disagree.
 */
export function ReviewModule() {
  const navigate = useNavigate();
  const { result } = useRun();
  const config = useAppConfig();

  if (!result) {
    return (
      <PageShell>
        <PageHeader title="Review" />
        <EmptyState
          icon={<icons.FileSpreadsheet size={28} />}
          title="No reconciliation yet"
          description="Upload both workbooks to see the calculated costs and any variances."
          action={<Button onClick={() => void navigate("/run")}>Start a run</Button>}
        />
      </PageShell>
    );
  }

  const threshold = config.data?.defaults.customs_variance_threshold ?? 200;
  const { tabs, active, setActive, selectedPo, togglePo, closePo } = useReviewTabs(result);
  const openOrder = result.purchase_orders.find((order) => order.po === selectedPo) ?? null;

  return (
    <PageShell width="wide">
      <PageHeader
        title="Review"
        description={`Close ${result.parameters.close_month} at a landing rate of ${result.parameters.landing_rate}.`}
        action={
          <Button variant="secondary" onClick={() => void navigate("/reconciliation")}>
            Compare against booked
          </Button>
        }
      />

      <RunSummary totals={result.totals} threshold={threshold} />

      <Tabs tabs={tabs} activeId={active} onChange={setActive} />

      <div className={styles.panel}>
        <ReviewPanelView
          active={active}
          result={result}
          threshold={threshold}
          selectedPo={selectedPo}
          openOrder={openOrder}
          onSelectPo={togglePo}
          onClosePo={closePo}
        />
      </div>
    </PageShell>
  );
}
